/*!
 * @piconetworks/text v3.1.3
 * (c) 
 */
'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var cx = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var styles$4 = {"span":"Span-module_span__3kknx"};

var Span = function Span(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default['default'].createElement("span", _extends({
    className: cx__default['default'](styles$4.span, className)
  }, props, {
    "data-testid": "Span_index_span"
  }), children);
};

Span.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};

var styles$3 = {"badge":"Badge-module_badge__ks_VE","primary":"Badge-module_primary__1U_2j","focus":"Badge-module_focus__N4_qh","secondary":"Badge-module_secondary__26McL","success":"Badge-module_success__25qTd","info":"Badge-module_info__2kYCO","warning":"Badge-module_warning__22iAH","danger":"Badge-module_danger__19ACl","light":"Badge-module_light__3n0Pp","dark":"Badge-module_dark__5lynU","facebook":"Badge-module_facebook__20NYg","google":"Badge-module_google__1yv0r","caps":"Badge-module_caps__9-ofU"};

var Badge = function Badge(_ref) {
  var as = _ref.as,
      caps = _ref.caps,
      children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["as", "caps", "children", "className", "variant"]);

  var Component = as || Span;
  return /*#__PURE__*/React__default['default'].createElement(Component, _extends({
    className: cx__default['default'](styles$3.badge, variant && styles$3[variant], caps && styles$3.caps, className)
  }, props, {
    "data-testid": "Badge_index_Component"
  }), "\xA0", children);
};

Badge.propTypes = {
  as: PropTypes__default['default'].any,
  caps: PropTypes__default['default'].bool,
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  variant: PropTypes__default['default'].oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light', 'link', 'facebook', 'google'])
};
Badge.defaultProps = {
  caps: true
};

var styles$2 = {};

var P = function P(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default['default'].createElement("p", _extends({
    className: cx__default['default'](styles$2.p, className)
  }, props, {
    "data-testid": "P_index_p"
  }), children);
};

P.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object])
};

var styles$1 = {"small":"Small-module_small__l7JNW","secondary":"Small-module_secondary__1Jx7i","error":"Small-module_error__Mo_-m"};

var Small = function Small(_ref) {
  var children = _ref.children,
      variant = _ref.variant,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "variant", "className"]);

  return /*#__PURE__*/React__default['default'].createElement("small", _extends({
    className: cx__default['default'](styles$1.small, styles$1[variant], className)
  }, props, {
    "data-testid": "Small_index_small"
  }), children);
};

Small.defaultProps = {
  variant: 'default'
};
Small.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  children: PropTypes__default['default'].node,
  variant: PropTypes__default['default'].string
};

var styles = {"tiny":"Tiny-module_tiny__1bq33"};

var Tiny = function Tiny(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default['default'].createElement("small", _extends({
    className: cx__default['default'](styles.tiny, className)
  }, props, {
    "data-testid": "Tiny_index_small"
  }), children);
};

Tiny.propTypes = {
  className: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].object]),
  children: PropTypes__default['default'].node
};

var Text = {
  Badge: Badge,
  P: P,
  Span: Span,
  Small: Small,
  Tiny: Tiny
};

module.exports = Text;
